import { env } from '../../env';
import { fetchData } from '../../sagas/fetchUtils';

const { GAP_CORRECTION_PATH } = env.runtimeConfig.backend;

const url = GAP_CORRECTION_PATH;

const getGapAffected = (injectedFetch = fetchData) => injectedFetch(url)
    .then(res => {
        if (res.error) {
            return { hasAffected: false };
        }
        return res;
    })
    .catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return { hasAffected: false };
    });

export default getGapAffected;
